import axios from "axios";
import { getFingerprint } from "../utils/fingerprint.js";

const $host = axios.create({
    // baseURL: "http://127.0.0.1:4500"
    baseURL: "https://map.infosys05.ru"
    // baseURL: process.env.REACT_APP_API_URL

})

const $authHost = axios.create({
    // baseURL: "http://127.0.0.1:4500"
    baseURL: "https://map.infosys05.ru"
    // baseURL: process.env.REACT_APP_API_URL
})

const authInterceptor = async config => {
    config.headers.authorization = `Bearer ${localStorage.getItem('token')}`;
    
    // Добавляем fingerprint в заголовки для всех авторизованных запросов
    try {
        const fingerprint = await getFingerprint();
        config.headers['X-Fingerprint'] = fingerprint;
    } catch (error) {
        console.warn('Failed to get fingerprint for request:', error);
    }
    
    return config;
}

$authHost.interceptors.request.use(authInterceptor)

export {
    $host,
    $authHost
}